import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../../../messages';
import { CryptoWithdrawCompleteComponent } from './components/CryptoWithdrawComplete';

export const Route = createFileRoute('/_authenticated/funds/withdraw/crypto/$productCode/complete')({
  component: CryptoWithdrawComplete,
});

function CryptoWithdrawComplete() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const { withdrawProductData } = useSelector(
    (rootState: RootState) => rootState.funds,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/withdraw/crypto/${withdrawProductData.code}/complete`}
      />
      <div className="px-6 py-4">
        <CryptoWithdrawCompleteComponent />
      </div>
    </>
  );
}
